module.exports = __webpack_public_path__ + "assets/53f84771383b0bb4f9caca0812d0bb36.mp3";